var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"img-container"},[_c('img',{staticStyle:{"height":"80%","width":"80%"},attrs:{"src":require("./img/icons8-chatgpt-480.png"),"alt":""}})])])
}]

export { render, staticRenderFns }